module.exports = __webpack_public_path__ + "img/nacs-circle.d49be0ac.png";